import {
    LESS_984_MEDIA_QUERY,
    LESS_512_MEDIA_QUERY,
} from '../../../../../consts/adaptive';

const font = {
    fontStyle: 'normal',
    fontWeight: 400,
};

const weightFont = {
    fontStyle: 'normal',
    fontWeight: 700,
};

const grayLine = '2px solid #E7E7E7';
const rightSideWidth = 210;

export const styles = {
    container: {
        display: 'flex',
        marginTop: 6,
    },
    answerContent: {
        height: 'fit-content',
        padding: 16,
        display: 'flex',
        background: '#E7E7E7',
        borderRadius: '8px',
    },
    answerContentInner: {
        overflow: 'hidden',
        display: '-webkit-box',
        flexDirection: 'column',
        [`-webkit-box-orient`]: 'vertical',
        [`-webkit-line-clamp`]: 3,
    },
    answerArrow: {
        position: 'relative',
        top: -17,
        width: 28,
        height: 56,
        borderBottom: grayLine,
        borderLeft: grayLine,
        borderRadius: [0, 0, 0, 8],
        flexShrink: 0,
    },
    answerText: {
        paddingRight: 27,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#000000',
        ...font,
    },
    reviewTextDetail: {
        [`-webkit-line-clamp`]: 'inherit',
    },
    answerInfo: {
        height: 'auto',
        width: rightSideWidth,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        flexShrink: 0,
    },
    companyName: {
        fontSize: '14px',
        lineHeight: '19px',
        color: '#313140',
        ...weightFont,
    },
    answerCreated: {
        fontSize: '14px',
        lineHeight: '14px',
        color: '#9B9B9B',
        ...font,
    },
    moreInfoButton: {
        padding: '11px 0 0',
        margin: 0,
        fontFamily: 'Open Sans, sans-serif',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '10px',
        color: '#3d95fb',
        lineHeight: '14px',
        textTransform: 'uppercase',
        border: 'none',
        background: 'none',
        cursor: 'pointer',

        ['&:hover']: {
            color: '#2087ff',
        },
    },
    [LESS_984_MEDIA_QUERY]: {
        answerContent: {
            padding: [10, 16],
            flexDirection: 'column',
        },
        answerInfo: {
            width: 'auto',
            flexDirection: 'row',
        },
        answerCreated: {
            fontSize: '10px',
        },
        answerText: {
            margin: 0,
            paddingRight: 0,
        },
    },
    [LESS_512_MEDIA_QUERY]: {
        answerText: {
            fontSize: '12px',
        },
        companyName: {
            fontSize: '8px',
        },
        answerCreated: {
            fontSize: '8px',
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
